export interface SetMerchantId {
  type: "SET_MERCHANT_ID";
  data: string;
}

export function setMerchantId(merchantId: string): SetMerchantId {
  return {
    type: "SET_MERCHANT_ID",
    data: merchantId,
  };
}
